import styled from 'styled-components';

export const Content = styled.div`
  flex: 1 1 100%;
  background-color: var(--page-background);
`;
